<div class="table-responsive">
  <table class="table align-items-center table-flush">
    <thead class="thead-light">
    <tr>
      <th scope="col">Report Type</th>
      <th scope="col">Submitted Date</th>
    </tr>
    </thead>

    <tbody class="list">
    <tr *ngFor="let item of reportType; index as i">
      <td>
        {{ item.name }}
      </td>
      <td>
        <span class="mr-4 text-wrap">
          <span class="status ">{{ item.submitDate|date :'dd/MM/YYYY' }}</span>
        </span>
      </td>
    </tr>
    </tbody>
  </table>
</div>


